// src/components/Billing/LicenseBillingAlert.jsx
import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../util/araknerdlib";

const LicenseBillingAlert = ({
  show,
  amount,
  currency = "UGX",
  dueDate,
  graceUntil,
  className = "",
}) => {
  if (!show) return null;

  const formatCurrency = (v) =>
    `${currency} ${Number(v || 0).toLocaleString("en-UG")}`;

  return (
    <div
      className={`alert alert-warning d-flex align-items-center justify-content-between shadow-sm ${className}`}
      role="alert"
      style={{ borderLeft: "4px solid #ffba00" }}
    >
      <div className="d-flex align-items-start">
        <i className="fe fe-alert-triangle text-warning mr-2 tx-20" />
        <div>
          <strong>Unpaid License Invoice</strong>
          <div className="tx-13 mt-1">
            You have a pending license invoice of{" "}
            <b>{formatCurrency(amount)}</b>
            {dueDate ? (
              <>
                {" "}
                due by <b>{formatDate(dueDate)}</b>. Please make a payment by <b>{formatDate(graceUntil)}</b> to avoid service
                interruption.
              </>
            ) : (
              "."
            )}
          </div>
        </div>
      </div>

      <Link
        to="/license"
        className="btn btn-sm btn-primary ml-3"
        style={{ whiteSpace: "nowrap" }}
      >
        <i className="fe fe-credit-card mr-1" />
        Pay Now
      </Link>
    </div>
  );
};

export default LicenseBillingAlert;
